import { render, staticRenderFns } from "./TopNavigator.vue?vue&type=template&id=0f892df4&"
import script from "./TopNavigator.vue?vue&type=script&lang=js&"
export * from "./TopNavigator.vue?vue&type=script&lang=js&"
import style0 from "./TopNavigator.vue?vue&type=style&index=0&id=0f892df4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports